import type { MessageDescriptor } from 'react-intl';

export const RECOMMENDATION_DISPLAY_TYPES = {
  FLOATING_CARD: 'floatingCard',
  POPOVER_CARD: 'popoverCard',
} as const;

export type FloatingCardConfig = {
  displayType: typeof RECOMMENDATION_DISPLAY_TYPES.FLOATING_CARD;
  title: MessageDescriptor;
  content: MessageDescriptor;
  buttonLabel: MessageDescriptor;
  learnMoreLinkId?: string;
  isDismissible?: boolean;
};

export type PopoverCardConfig = {
  displayType: typeof RECOMMENDATION_DISPLAY_TYPES.POPOVER_CARD;
  title: MessageDescriptor;
  content: MessageDescriptor;
  buttonLabel: MessageDescriptor;
  learnMoreLinkId?: string;
  isDismissible?: boolean;
  illustrationSrc: string;
};

export type RecommendationDisplayConfig = FloatingCardConfig | PopoverCardConfig;
